import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {AppConfigService} from '../../../Services/app-config.service';
import {ProjectDashboardSummary} from '../../../DataModels/project.model';

@Component({
  selector: 'app-project-dashboard',
  templateUrl: './project-dashboard.component.html',
  styleUrls: ['./project-dashboard.component.css'],
  standalone: false
})
export class ProjectDashboardComponent implements OnInit {
  vm: any = {
    title: 'Project Dashboard',
    dashboard: null as ProjectDashboardSummary,
    company: [],
    selectedCompanyId: '',
    permissions: [],
    Preferences: [],
    listRoute: '/projects/project-list',
    formRoute: '/projects/project-form',
  };

  isLoaded = false;

  constructor(
    private titleService: Title,
    private tableDataService: DataService,
    private localStorage: StorageService,
    private notification: BsToastService,
    private appConfig: AppConfigService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle(this.vm.title);
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    this.loadCompanies();
  }

  loadCompanies() {
    this.tableDataService.getData('company?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: any) => {
        this.vm.company = result.Data || [];
        this.vm.selectedCompanyId = this.vm.Preferences?.defaults?.company_id ?? '';
        this.loadData();
      },
      error: () => {
        this.vm.selectedCompanyId = this.vm.Preferences?.defaults?.company_id ?? '';
        this.loadData();
      },
    });
  }

  onCompanyChange() {
    this.loadData();
  }

  loadData() {
    const companyId = this.vm.selectedCompanyId ?? '';
    this.tableDataService.getDataWithParams('project-dashboard', 'company_id=' + companyId).subscribe({
      next: (result: ProjectDashboardSummary) => {
        this.vm.dashboard = result;
        this.isLoaded = true;
      },
      error: (err) => {
        console.error(err);
        this.notification.showErrorToast('Error loading project dashboard');
      },
    });
  }

  onNewProject() {
    this.router.navigate([this.vm.formRoute]).then();
  }

  onViewList() {
    this.router.navigate([this.vm.listRoute]).then();
  }

  onViewProject(id: string) {
    this.router.navigate(['/projects/project-detail'], {queryParams: {id}}).then();
  }
}
